export const scrollTop = () => {
  const element = document.getElementsByClassName('Layout-scroller').item(0)
  if (element) {
    element.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
